import * as angular from "angular";
import {IController} from "angular";
import {accessorialsPricingType} from "../../../price-plan/types/accessorialsPricing.type";
import * as _ from "lodash";

export class preferencesValueEditCtrl implements IController {

  form: any;
  property: any;
  programs: any;
  onChange: Function;

  public propertyCopy: any;
  public useDefault: boolean = false;
  public valueInPercentage: any;
  public dimensions: any;
  public accessorial: any;
  public accessorialPriceTypes: any;
  public time: any;

  /* @ngInject */
  constructor(private moment) {
  }

  $onInit() {
    this.propertyCopy = angular.copy(this.property);

    if (_.isUndefined(this.propertyCopy?.value)) {
      this.propertyCopy.value = this.property.defaultValue;
    }

    // Checks if value type Dimensions is string and parse it.
    if (this.propertyCopy.valueType === 'Dimensions' && this.propertyCopy.key === 'SPOT_DIMENSIONS') {
      this.dimensions = JSON.parse(this.propertyCopy.value);
      return;
    }

    // Checks if value type Accessorial is string and parse it.
    if (this.propertyCopy.valueType === 'Accessorial') {
      this.accessorial = JSON.parse(this.propertyCopy.value);
      this.accessorialPriceTypes = accessorialsPricingType;
      return;
    }

    // Checks if value type Boolean/Float/Integer/Long is string and parse it.
    if (this.property.valueType === 'Boolean' || this.property.valueType === 'Float' ||
      this.property.valueType === 'Integer' || this.property.valueType === 'Long') {
      this.propertyCopy.value = JSON.parse(this.propertyCopy.value);
    }

    if (this.property.valueType === 'Date') {
      const parsed = JSON.parse(this.property.value);
      this.propertyCopy.value = new Date(parsed);
    }

    if (this.property.valueType === 'DateRange') {
      if (this.property.value) {
        this.propertyCopy.value = JSON.parse(this.property.value)
      } else {
        this.propertyCopy.value = {from: undefined, to: undefined};
      }
    }

    if (this.property.valueType === 'MultiSelect' || this.property.valueType === 'OptionsList') {
      this.propertyCopy.value = JSON.parse(this.property.value);
    }

    // Checks if Date value is string and parse it.
    if (this.propertyCopy.key === 'SITE_INFO_ADRRESS') {
      this.propertyCopy.address = {
        place: this.property.value
      };
    }

    if (this.propertyCopy.dataUnit === 'Percent') {
      this.valueInPercentage = this.propertyCopy.value * 100;
    }

    if (this.propertyCopy.valueType === 'DayTime') {
      this.time = new Date(`${this.moment().format('MM/DD/YYYY')} ${this.propertyCopy.value}`);
    }
  };

  $onChanges(changes) {
    if (changes.property && !changes.property.isFirstChange()) {
      this.$onInit();
    }
  }

  //////////////////////////////////////////////////////////////////

  onChangeString(string) {
    if (string === "") {
      string = undefined;
    }
    this.propertyCopy.value = string;
    this.onChange({property: this.propertyCopy});
  }

  onAddressChange(address) {
    this.propertyCopy.address = address;
    this.propertyCopy.value = address.place;
    this.onChange({property: this.propertyCopy});
  }

  onChangeDate(date) {
    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = this.moment(date).valueOf();
    this.onChange({property: propertyToUpdate});
  }

  onRangeChange(from, to) {
    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = {
      from: from,
      to: to
    };
    propertyToUpdate.value = JSON.stringify(propertyToUpdate.value);
    this.onChange({property: propertyToUpdate});
  }

  onChangeSelect(values) {
    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = JSON.stringify(values)
    this.onChange({property: propertyToUpdate});
  }

  onOptionsChanged(values) {
    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = JSON.stringify(values);
    this.onChange({property: propertyToUpdate});
  }

  onSelectProgram(programId) {
    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = programId
    this.onChange({property: propertyToUpdate});
  }

  onChangeDayTime(time) {
    let propertyToUpdate = angular.copy(this.propertyCopy);

    var formattedHour = time.getHours() < 10 ? "0" + time.getHours() : time.getHours();
    var formattedMinute = time.getMinutes() < 10 ? "0" + time.getMinutes() : time.getMinutes();

    propertyToUpdate.value = formattedHour + ":" + formattedMinute;
    this.onChange({property: propertyToUpdate});
  }

  onChangePercentage(percentage) {
    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = percentage;
    this.onChange({property: propertyToUpdate});
  }

  onChangeDimensions(dimensions) {
    this.dimensions = dimensions;

    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = JSON.stringify(dimensions);
    this.onChange({property: propertyToUpdate});
  }

  onChangeAccessorial(accessorial) {
    this.accessorial = accessorial;

    let propertyToUpdate = angular.copy(this.propertyCopy);
    propertyToUpdate.value = JSON.stringify(accessorial);
    this.onChange({property: propertyToUpdate});
  }

}

angular
  .module('bringoz.admin.site-preferences')
  .component('preferencesValueEdit', {
    require: {
      form: '^form'
    },
    bindings: {
      property: '<',
      programs: '<?',
      onChange: '&'
    },
    template: require('./preferences-value-edit.html').default,
    controller: preferencesValueEditCtrl
  });
